/* Participant details belong to the selected course line, never to browser storage. */
(function () {
  'use strict';
  document.querySelectorAll('[data-bd156-product-people]').forEach(holder => {
    const form = holder.closest('form');
    if (!form || holder.dataset.ready) return;
    const quantity = form.querySelector('[name="quantity"]');
    const persons = holder.querySelector('[data-bd156-persons]');
    const generated = holder.querySelector('[data-bd156-properties]');
    if (holder.dataset.bookingAudience === 'public') {
      if (!window.BDPublicParticipants) { form.addEventListener('submit', event => event.preventDefault()); return; }
      const ui = window.BDPublicParticipants.mount(holder, quantity, {}, {persons:'[data-bd156-persons]', count:'[data-bd156-count]'});
      const booking = crypto.randomUUID();
      quantity.max = '20'; form.noValidate = true;
      form.addEventListener('submit', event => {
        ui.sync();
        const count = Number(quantity.value);
        quantity.setCustomValidity(Number.isInteger(count) && count >= 1 && count <= 20 ? '' : 'Bitte wählen Sie 1 bis 20 Plätze.');
        if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        generated.replaceChildren();
        Object.entries(ui.properties({_bd155_booking:booking})).forEach(([name,value]) => {
          const input = document.createElement('input'); input.type = 'hidden';
          input.name = 'properties[' + name + ']'; input.value = value; generated.append(input);
        });
      }, true);
      quantity.addEventListener('input', () => quantity.setCustomValidity(''));
      holder.dataset.ready = 'true'; return;
    }
    const fields = [
      ['first', 'Vorname', 'text', 80], ['last', 'Nachname', 'text', 80],
      ['street', 'Strasse und Hausnummer', 'text', 120], ['zip', 'PLZ', 'text', 16],
      ['city', 'Ort', 'text', 80], ['phone', 'Telefon', 'tel', 40],
      ['email', 'E-Mail', 'email', 160]
    ];
    const key = (i, field) => '_bd155_p' + String(i).padStart(2, '0') + '_' + field;
    const booking = crypto.randomUUID();
    const hidden = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[' + name + ']'; input.value = value;
      generated.append(input);
    };
    function sync() {
      const count = Math.max(0, Math.min(20, Number.isInteger(Number(quantity.value)) ? Number(quantity.value) : 0));
      while (persons.children.length < count) {
        const i = persons.children.length + 1;
        const person = document.createElement('fieldset');
        person.className = 'bd155-person'; person.dataset.person = String(i);
        const legend = document.createElement('legend'); legend.textContent = 'Teilnehmende Person ' + i;
        const later = document.createElement('label'); later.className = 'bd155-defer';
        const check = document.createElement('input'); check.type = 'checkbox'; check.dataset.defer = '';
        const laterText = document.createElement('span'); laterText.textContent = 'Angaben zu dieser Person werden später nachgereicht.';
        later.append(check, laterText);
        const grid = document.createElement('div'); grid.className = 'bd155-fields';
        fields.forEach(([field, labelText, type, max]) => {
          const label = document.createElement('label');
          const text = document.createElement('span'); text.textContent = labelText;
          const input = document.createElement('input');
          input.type = type; input.maxLength = max; input.autocomplete = 'off';
          input.name = 'properties[' + key(i, field) + ']'; input.dataset.field = field;
          input.addEventListener('input', () => input.setCustomValidity(''));
          label.append(text, input); grid.append(label);
        });
        person.append(legend, later, grid); persons.append(person);
        check.addEventListener('change', sync);
      }
      Array.from(persons.children).forEach((person, index) => {
        const active = index < count;
        person.hidden = !active; person.disabled = !active;
        const later = person.querySelector('[data-defer]').checked;
        person.querySelectorAll('[data-field]').forEach(input => {
          input.required = active && !later;
          if (!input.required) input.setCustomValidity('');
        });
      });
      holder.querySelector('[data-bd156-count]').textContent = count + ' Person(en) für diesen Kurs';
    }
    quantity.max = '20';
    quantity.addEventListener('input', () => { quantity.setCustomValidity(''); sync(); });
    form.noValidate = true;
    form.addEventListener('submit', event => {
      sync();
      const count = Number(quantity.value);
      quantity.setCustomValidity(Number.isInteger(count) && count >= 1 && count <= 20 ? '' : 'Bitte wählen Sie 1 bis 20 Plätze.');
      const active = Array.from(persons.children).filter(person => !person.hidden);
      active.forEach(person => person.querySelectorAll('[data-field]').forEach(input => {
        input.value = input.value.trim();
        input.setCustomValidity(input.required && !input.value ? 'Bitte ausfüllen oder für diese Person «Angaben werden später nachgereicht» wählen.' : '');
      }));
      if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      generated.replaceChildren();
      hidden('_bd155_booking', booking);
      let deferred = 0;
      active.forEach(person => {
        const i = Number(person.dataset.person);
        const later = person.querySelector('[data-defer]').checked;
        hidden(key(i, 'defer'), later ? 'ja' : 'nein');
        if (later) deferred += 1;
        const name = ['first', 'last'].map(field => person.querySelector('[data-field="' + field + '"]').value).filter(Boolean).join(' ');
        hidden('Teilnehmende Person ' + String(i).padStart(2, '0'), name ? name + (later ? ' (weitere Angaben folgen)' : '') : 'Angaben folgen');
      });
      hidden('Teilnehmendenangaben', active.length + ' Person(en); ' + deferred + ' nachzureichen');
    }, true);
    sync(); holder.dataset.ready = 'true';
  });
})();
